import { useRoutes, Navigate, useLocation } from "react-router-dom";
import Layout from "./layout";
import Home from "./pages/home";
import Product from "./pages/product/list";
import ProductDetail from "./pages/product/detail";
import SafetyGas from "./pages/safetyGas/list";
import SafetyGasDetail from "./pages/safetyGas/detail";
import SubLayout from "./pages/service/subLayout";
import ServiceHome from "./pages/service/home";
import OrderList from "./pages/service/order/list";
import OrderDetail from "./pages/service/order/detail";
import Balance from "./pages/service/balance";
import Reconcile from "./pages/service/reconcile";
import Invoice from "./pages/service/invoice";
import LiquidLevel from "./pages/service/liquidLevel";
import Uppassword from "./pages/service/uppassword";
import QuickOrder from "./pages/service/quickOrder";
import Announcement from "./pages/service/announcement/list";
import AnnouncementDetail from "./pages/service/announcement/detail";
import Permissions from "./pages/permissions";
import Forget from "./pages/forget";
import Reset from "./pages/reset";
import Login from "./pages/login";
import { useUserInfo } from "@/model";
import { useMemo } from "react";
import { hasPermission } from "./utils";
import _ from "lodash";

// 服务中心
export const centerRoutes: ROUTE.RouteItem = {
  path: "service",
  element: <SubLayout />,
  meta: {
    needLogin: true,
  },
  children: [
    {
      path: "",
      element: <Navigate to="/service/center" />,
    },
    {
      path: "center", // 服务中心
      element: <ServiceHome />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "orderList", // 我的订单
      element: <OrderList />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "orderDetail", // 订单详情
      element: <OrderDetail />,
      meta: {
        needLogin: true,
      },
    },
    {
      path: "balance", // 我的余额
      element: <Balance />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "reconcile", // 对帐函
      element: <Reconcile />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "invoice", // 发票
      element: <Invoice />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "liquidLevel", // 液位管理
      element: <LiquidLevel />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "uppassword", // 修改密码
      element: <Uppassword />,
      meta: {
        needPermissions: true,
      },
    },
    {
      path: "announcement", // 公告查询
      element: <Announcement />,
    },
    {
      path: "announcement/detail", // 公告详情
      element: <AnnouncementDetail />,
    },
  ],
};

export const routes: ROUTE.RouteItem[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        // index: true,
        path: "",
        element: <Navigate to="/home" />,
      },
      // 首页
      {
        path: "/home",
        children: [
          {
            path: "",
            element: <Home />,
          },
        ],
      },
      // 产品中心
      {
        path: "/good/list",
        element: <Product />,
      },
      {
        path: "/good/detail/:id",
        element: <ProductDetail />,
      },
      // 安全用气
      {
        path: "/safetyGas",
        element: <SafetyGas />,
      },
      {
        path: "/safetyGas/safetyGasDetail/:id",
        element: <SafetyGasDetail />,
      },
      // 服务中心
      centerRoutes,
      // 快速下单
      {
        path: "quickOrder/dytOrder/:id?",
        element: <QuickOrder />,
        meta: {
          needLogin: true,
        },
      },
      {
        path: "reset", // 登陆重置密码
        element: <Reset />,
      },
      // 忘记密码
      {
        path: "forget",
        element: <Forget />,
      }
    ],
  },
  {
    path: "/safetyGas/weiDetail/:id",
    element: <SafetyGasDetail />,
  },
  {
    path: "login",
    element: <Login />,
  },
  
  {
    path: "*",
    element: <p>this is 404</p>,
  },
];

const renderRoute = (
  routes: ROUTE.RouteItem[],
  isLogin: boolean,
  permissionsList: string[],
  pathname: string
) => {
  return routes.map((el) => {
    if (el.meta?.needLogin && !isLogin) {
      el.element = <Permissions />;
      return el;
    }
    if (el.meta?.needPermissions) {
      const isPermissions = hasPermission(permissionsList, pathname);
      if (!isPermissions) {
        el.element = <Permissions />;
        return el;
      }
    }
    // if (el.meta?.hideMenu) {
    //   el.element = <p>我是没有权限的页面</p>
    // }
    // if (el.meta?.title === "应用") {
    //   el.oriElement = el.element;
    //   el.element = <Navigate to="/demo/123" />
    // } else if (el.oriElement) {
    //   el.element = el.oriElement;
    //   el.oriElement = null;
    // }
    if (el.children) {
      el.children = renderRoute(
        el.children,
        isLogin,
        permissionsList,
        pathname
      );
    }
    return el;
  });
};

const Routes = () => {
  const userInfo = useUserInfo();
  const location = useLocation();

  const routerList = useMemo(() => {
    const isLogin = !!(userInfo.loginInfo && userInfo.curUserInfo);
    const permissionsList: string[] = [];
    if (userInfo.serviceMenuItems && userInfo.serviceMenuItems.children) {
      const dfs: (root: any) => void = (root) => {
        if (!root) return;
        const { resources, children = [] } = root;
        if (resources) {
          permissionsList.push(resources);
        }
        children.forEach((el: any) => {
          dfs(el);
        });
      };
      dfs(userInfo.serviceMenuItems);
    }

    const _routes = _.cloneDeep(routes);
    return renderRoute(
      _routes,
      isLogin,
      permissionsList || [],
      location.pathname
    );
  }, [
    userInfo.loginInfo,
    userInfo.curUserInfo,
    location.pathname,
    userInfo.serviceMenuItems,
  ]);

  // useEffect(() => {
  //   console.log("menuList1111", userInfo.serviceMenuItems);
  // }, [userInfo.serviceMenuItems, userInfo.loginInfo, userInfo.curUserInfo]);

  // return useRoutes(renderRoute(routes));
  return useRoutes(routerList);
};
export default Routes;
